export default __webpack_public_path__ + "0c919c484680e89acbc71fadcfaf186e.svg";